export const MARKS = {
  wholeDay: 'Ganzer Tag. Keine Kombination nötig.',
  covers: 'Kombination deckt',
  doesNotCover: 'Kombination deckt nicht',
  asked: 'schon gefragt',
  covered: 'schon gedeckt',
  uncovered: 'ungedeckt',
  thin: 'unter der Schwelle',
  ok: 'gedeckt',
} as const

export const SETTLED_MARKS = new Set<string>([MARKS.asked, MARKS.covered])
